import axios from 'axios'
import { getSavedState, saveState } from '@state/helpers'

export const state = {
  paypalToken: getSavedState('order.paypalToken'),
  cart: getSavedState('order.cart'),
}

export const getters = {}

export const mutations = {
  SET_PAYPAL_TOKEN(state, newValue) {
    state.paypalToken = newValue
    saveState('order.paypalToken', newValue)
  },
  SET_CART(state, newValue) {
    state.cart = newValue
    saveState('order.cart', newValue)
  },
}

export const actions = {
  checkout({ commit, state }, data) {
    return axios
      .post('/consumer-api/creditCard/v1/purchase', data)
      .then((response) => {
        const transactionDetails = response.data
        commit('customer/UPDATE_CART', null, { root: true })
        return {
          tax: transactionDetails.tax.toFixed(2),
          transactionId: transactionDetails.transactionId,
          name: transactionDetails.name,
          price: transactionDetails.price,
          image: transactionDetails.image,
          htmlDescription: transactionDetails.htmlDescription,
          code: transactionDetails.code,
          orderTotal: (
            transactionDetails.tax + transactionDetails.price
          ).toFixed(2),
          firstName: data.billingAddress.firstName,
          lastName: data.billingAddress.lastName,
          creditCardType: data.card.cardType,
          creditCardNumber: data.card.ccNumber.substr(-4, 4),
          expirationMonth: data.card.expirationMonth,
          expirationYear: data.card.expirationYear,
          address: data.billingAddress.address1,
          apartmentNo: data.billingAddress.address2,
          city: data.billingAddress.city,
          state: data.billingAddress.state,
          zipCode: data.billingAddress.postalCode,
        }
      })
      .catch((error) => {
        let errorMessage
        switch (error.response.status) {
          case 402:
          case 422:
            errorMessage = 'Purchase was declined'
            break
          default:
            errorMessage = 'There was an error processing this transaction'
        }

        // Reject the promise is required to trigger error on response
        return Promise.reject(errorMessage)
      })
  },
  checkoutVoucher({ commit, state }, data) {
    return axios
      .post('/consumer-api/voucher/v1/purchase', data)
      .then((response) => {
        const transactionDetails = response.data
        commit('customer/UPDATE_CART', null, { root: true })
        return {
          tax: transactionDetails.tax.toFixed(2),
          transactionId: transactionDetails.transactionId,
          name: transactionDetails.name,
          price: transactionDetails.price,
          image: transactionDetails.image,
          htmlDescription: transactionDetails.htmlDescription,
          code: transactionDetails.code,
          orderTotal: (0.0).toFixed(2),
          firstName: data.billingAddress.firstName,
          lastName: data.billingAddress.lastName,
          address: data.billingAddress.streetName,
          city: data.billingAddress.town,
          state: data.billingAddress.region,
          zipCode: data.billingAddress.postalCode,
          voucher: data.voucherCode,
          productName: data.productName,
        }
      })
      .catch((error) => {
        let errorMessage
        switch (error.response.status) {
          case 402:
          case 422:
            errorMessage = 'Purchase was declined'
            break
          default:
            errorMessage = 'There was an error processing this transaction'
        }

        // Reject the promise is required to trigger error on response
        return Promise.reject(errorMessage)
      })
  },
  checkoutPaypal({ commit, state }, data) {
    return axios
      .post('/consumer-api/paypal/v1/authorizeexpresscheckout', data)
      .then((response) => {
        const authorizationResponse = response.data
        const token = authorizationResponse.substring(
          authorizationResponse.indexOf('token=') + 6
        )

        commit('SET_PAYPAL_TOKEN', token)
        commit('SET_CART', data)
        return authorizationResponse
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })
  },
  validateVoucher({ commit, state }, { voucher, code }) {
    return axios
      .get(`/consumer-api/voucher/v1/validate/${voucher}/product/${code}`)
      .then((response) => {
        return response
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        const rejectedMessage =
          "Please check your code and try again: Has it expired? Was it entered correctly? We don't recognize it"
        if (error.response.status === 404 || error.response.status === 400) {
          return Promise.reject(rejectedMessage)
        } else {
          return Promise.reject(error.response.data.message)
        }
      })
  },
  checkoutPaypalSuccess({ commit, state }) {
    let config = {
      headers: {
        'PP-TOKEN': state.paypalToken,
      },
    }
    return axios
      .post(
        '/consumer-api/paypal/v1/dopaypalexpresscheckout',
        state.cart,
        config
      )
      .then((response) => {
        const transactionDetails = response.data

        return transactionDetails
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })
  },
}
